import { checkSafari } from "project-config/utils";
export function payWithPaypal(html: string, callback?: () => void) {
  const target = checkSafari() ? "_self" : "_blank";
  const blockPopup = window.open("about:blank", target);
  if (!blockPopup) return;

  blockPopup.location = html;

  callback?.();
}
